import React, { useEffect } from 'react';
import {
  IonButton,
  IonInput,
  IonItem,
  IonList,
  IonSelect,
  IonSelectOption,
} from '@ionic/react';
import { useTranslation } from 'react-i18next';
import { AccountSecurityQuestion } from '../../services/types/apitypes';
import { uiInputMode } from '../../utils/ui';
import { useWeglot } from '../../context/WeglotContext';

type AccountQuestionsAuthProps = {
  securityAnswer: string;
  isValid: boolean;
  proceed: () => void;
  setSecurityAnswer: (s: string) => void;
  securityQuestions?: AccountSecurityQuestion[];
  setSecurityQuestion: (s: AccountSecurityQuestion) => void;
};

export default function AccountQuestionsAuth({
  isValid,
  securityQuestions,
  setSecurityQuestion,
  securityAnswer,
  setSecurityAnswer,
  proceed,
}: AccountQuestionsAuthProps) {
  const [t] = useTranslation('global');
  const { language, weglot } = useWeglot();
  const [questionText, setQuestionText] = React.useState<string>(
    t('questions.errorquestion') || '',
  );

  useEffect(() => {
    weglot.current?.translate(
      {
        words: [{ t: 1, w: t('questions.errorquestion') || '' }],
        languageTo: language,
      },
      (response: string) =>
        setQuestionText(response),
    );
  }, [language, t, weglot]);

  return (
    <>
      <h1 className="h1 h1plus ion-text-center">{t('questions.subtitle')}</h1>
      <p className="pt-2 pb-4 instructions ion-text-center">
        {t('questions.authinfo')}
      </p>
      <IonList inset={false}>
        <IonList>
          <IonItem
            lines="none"
            className="ion-no-padding ion-pt-1 pseudo-select"
          >
            <IonSelect
              placeholder={questionText}
              onIonChange={(e) => setSecurityQuestion(e.detail.value)}
            >
              {securityQuestions?.map((question) => (
                <IonSelectOption key={question.questionId} value={question}>
                  {question.questionText}
                </IonSelectOption>
              ))}
            </IonSelect>
          </IonItem>
          <IonItem lines="none" className="ion-no-padding ion-pt-1">
            <IonInput
              value={securityAnswer}
              mode={uiInputMode()}
              aria-label={t('questions.securityanswer')!}
              placeholder={t('questions.securityanswer')!}
              onIonInput={(e) => setSecurityAnswer(e.detail.value!)}
              type="text"
              fill="outline"
            ></IonInput>
          </IonItem>
        </IonList>
      </IonList>

      <div className="pt-4 ion-text-center">
        <IonButton
          className={
            'btn-default btn-wide-80 ' + (isValid ? '' : 'btn-disabled')
          }
          onClick={() => proceed()}
        >
          {t('questions.continue')}
        </IonButton>
      </div>
    </>
  );
}
